import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LoginGuard } from './login.guard';
import { AuthGuard } from '../shared/auth.guard';

const routes: Routes = [
  { path: 'signup', redirectTo: '/login/signup' },
  {
    path: 'login/:signup',
    component: LoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],

  exports: [RouterModule]
})
export class LoginRoutingModule {}
